import { DataGridPro } from "@mui/x-data-grid-pro";
import { Box, TableContainer } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRelatedOrders } from "../../../../store/actions/maintenanceBillToActions";
import {useHistory} from "react-router-dom";

export default function BillToRelatedOrderBy({ billToCode }) {
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 100,
  });
  const history = useHistory();

  const ordersLocation = useSelector(
    ({ orderReducer }) => orderReducer.ordersLocation,
  );

  useEffect(() => {
    if (!billToCode) return;

    let isMounted = true;

    const fetchRelatedOrders = async () => {
      setLoading(true);

      const res = await dispatch(
        getRelatedOrders(
          ordersLocation?.locationNumber,
          billToCode,
          paginationModel.page,
          paginationModel.pageSize,
        ),
      );

      if (!isMounted) return;

      setRows(res?.data || []);
      setTotalCount(res?.totCount || 0);
      setLoading(false);
    };

    fetchRelatedOrders();

    return () => {
      isMounted = false;
    };
  }, [paginationModel.page, paginationModel.pageSize, billToCode]);

  const handleCodeClick = (code) => {
    history.push("/order-by", { selectedOrderByCode: code });
  };

  const columns = [
    {
      field: "code",
      headerName: "Code",
      flex: 1,
      renderCell: (params) => (
        <span
          style={{
            textDecoration: "underline",
            cursor: "pointer",
            color: "#1a0dab",
          }}
          onClick={() => {
            console.log("Clicked code:", params.row.code);
            handleCodeClick(params.row.code);
          }}
        >
          {params.value}
        </span>
      ),
    },
    { field: "name", headerName: "Name", flex: 2 },
    { field: "location", headerName: "Location", flex: 1.5 },
    { field: "city", headerName: "City", flex: 1.5 },
    { field: "state", headerName: "State", flex: 0.8 },
  ];

  return (
    <TableContainer style={{ width: "100%" }}>
      <Box
        sx={{
          width: "100%",
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#0B4387",
            color: "#fff",
            fontWeight: 600,
            fontSize: "12px",
          },
          "& .MuiDataGrid-cell": {
            fontSize: "12px",
          },
        }}
      >
        <DataGridPro
          rows={rows}
          columns={columns}
          columnHeaderHeight={30}
          rowHeight={30}
          getRowId={(row) => row.code}
          pagination
          paginationMode="server"
          rowCount={totalCount}
          loading={loading}
          pageSizeOptions={[25, 50, 100]}
          paginationModel={paginationModel}
          onPaginationModelChange={(model) => setPaginationModel(model)}
        />
      </Box>
    </TableContainer>
  );
}
